const getListName = action => {
  switch(action){
  case 'remove':
  case 'reduce':
  case 'quantity': return 'items';
  case 'unreduce': return 'reduced';
  case 'unremove': return 'removed';
  }
};

module.exports = function({ order, params, isConsumer = true, strictEqual = true }){

  if(!params.action || !params.producerproduct_id){
    return false;
  }

  const list = getListName(params.action);

  const item = order[list].find(
    i => {
      return strictEqual
        ? i.producerproduct_id === params.producerproduct_id
        : i.producerproduct_id.equals(params.producerproduct_id);
    }
  );
  // action, quantity, percentage, reason, list, producerproduct_id

  if(!item){
    return false;
  }

  if(isConsumer){
    if(order.isCompiled()){
      return false;
    }
    if(list !== 'items'){
      return false;
    }
    if(params.quantity < 1){
      return false;
    }
    if(params.quantity > item.quantity){
      console.warn('UpdateItem quantity cannot be greater than existing quantity');
      return false;
    }
    // if(order.isPaid()){
    if(params.action !== 'remove'){
      console.warn('UpdateItem action must be "remove"');
      return false;
    }
    // }
    // else {
    //   if(params.action !== 'quantity'){
    //     console.warn('UpdateItem action must be "quantity"')
    //     return false;
    //   }
    // }
  }
  else {
    if(order.isCompiled()){
      if(!['remove','unremove','reduce','unreduce'].includes(params.action)){
        console.warn('UpdateItem action must be "remove", "unremove", "reduce", or "unreduce"');
        return false;
      }
      if(
        params.action === 'remove'
      ){
        if(!params.quantity || params.quantity > item.quantity){
          console.warn('UpdateItem quantity cannot be greater than existing quantity');
          return false;
        }
        if(typeof params.reason === 'undefined'){
          console.warn('UpdateItem remove must have a reason');
          return false;
        }
      }
      if(
        params.action === 'reduce'
      ){
        if(!params.quantity || params.quantity > item.quantity){
          console.warn('UpdateItem quantity cannot be greater than existing quantity');
          return false;
        }
        if(typeof params.reason === 'undefined' || typeof params.percentage === 'undefined'){
          console.warn('UpdateItem reduce must have a reason and a percentage');
          return false;
        }
      }
    }
    else {
      if(!['remove','unremove'].includes(params.action)){
        console.warn('UpdateItem action must be "remove" or "unremove"');
        return false;
      }
      if(params.action === 'remove'){
        if(!params.quantity || params.quantity > item.quantity){
          console.warn('UpdateItem quantity cannot be greater than existing quantity');
          return false;
        }
        if(typeof params.reason === 'undefined'){
          console.warn('UpdateItem remove must have a reason');
          return false;
        }
      }
      // unremove has no other params
    }
  }

  return true;
};